import type { Index } from 'hooks/type-of-use-indices'
import type { Product } from 'services/query-v2/products/index/product-info/model'
import ARTX_ICON from 'assets/overview/partners/artx-logo.png'
import JOOCE_ICON from 'assets/overview/partners/jooce-icon.png'
import COLONY_ICON from 'assets/overview/partners/colony-logo.png'

export const partnersList = [
  { name: 'Colony', icon: COLONY_ICON, link: 'https://www.colonylab.io/' },
  { name: 'JOOCE', icon: JOOCE_ICON, link: 'https://www.jooce.xyz/' },
  { name: 'ARTX', icon: ARTX_ICON, link: 'https://artx.capital/' },
]

export const byMarketcap = (a: Index, b: Index) => {
  return Number(a.marketCap) > Number(b.marketCap) ? -1 : 1
}

export const byProductMarketcap = (a: Product, b: Product) => {
  return Number(a.marketCap) > Number(b.marketCap) ? -1 : 1
}
/**
 * Used by the overview page, its forms part of the tuple state that is used to help the page determine what to show.
 * Then data comes back 'unknown' and is either cast to skeleton or the correct data based on inspection
 */
export interface SkeletonLoader {
  loading: boolean
}
